// extracted by mini-css-extract-plugin
export var markdown = "_sn-0";
export var tableWrapper = "_sn-1";